import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

// unregister (não register): o service worker da CRA cacheava agressivo e servia
// bundle VELHO após cada deploy (causa do "embolado"/telas desatualizadas). Com
// unregister, todo deploy aparece na hora e o SW existente é removido no 1º load.
serviceworker.unregister()